import { factory, Flex, Box, omitText, Typography, DsmColor, Link } from '@kohler-dsm-library/kohler-core';
import { ExternalLinkIcon, ArrowDownBoldIcon, ArrowRightBoldIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './OverlayMenuCategory.module.css.mjs';

const OverlayMenuCategory = factory((props, ref) => {
  const { className, title, links, showArrow = true, isExternal, opened = false, onToggle, isCTA = false, ...rest } = props;
  const isOpen = opened;
  const hasNoLinks = !links || links.length === 0;
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      ref,
      className: clsx(
        className,
        "kohler-overlay-menu-category-root",
        classes.overlayMenuCategory,
        isOpen && classes.overlayMenuCategoryOpen,
        isCTA && classes.overlayMenuCategoryCTA
      ),
      component: "div",
      ...rest
    },
    title && (!isCTA ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      /* @__PURE__ */ React.createElement(
        Box,
        {
          component: hasNoLinks ? "a" : "button",
          target: hasNoLinks && isExternal ? "_blank" : void 0,
          ...omitText(title),
          onClick: !links ? title.onClick : () => {
            if (onToggle) onToggle();
          },
          className: clsx(
            classes.overlayMenuCategoryTitle,
            hasNoLinks ? classes.overlayMenuCategoryTitleLink : void 0,
            title.className
          )
        },
        /* @__PURE__ */ React.createElement(Typography, { component: "span", size: "navigation-m", textColor: DsmColor.ContentPrimary }, title.text, " ", !showArrow && hasNoLinks && isExternal && /* @__PURE__ */ React.createElement(ExternalLinkIcon, { size: "small", withBoundingBox: false })),
        showArrow && !hasNoLinks && /* @__PURE__ */ React.createElement(
          ArrowDownBoldIcon,
          {
            size: "xSmall",
            withBoundingBox: false,
            className: clsx(classes.iconTransitionArrowClosed, isOpen && classes.iconTransitionArrowOpen, classes.arrowDownIcon)
          }
        )
      )
    ) : /* @__PURE__ */ React.createElement(Link, { size: "small", underline: false, rightIcon: /* @__PURE__ */ React.createElement(ArrowRightBoldIcon, { size: "small", withBoundingBox: false }), ...omitText(title) }, title.text)),
    (isOpen || !title) && /* @__PURE__ */ React.createElement(Flex, { component: "ul", direction: "column", gap: 15, margin: 0, className: classes.overlayMenuCategoryLinks }, !hasNoLinks && links?.map((link) => /* @__PURE__ */ React.createElement(Box, { key: link.href, component: "li" }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: "a",
        size: "navigation-s",
        textColor: DsmColor.ContentActionDefault,
        ...omitText(link),
        className: classes.overlayMenuCategoryLinksLink
      },
      link.text
    ))))
  );
});

export { OverlayMenuCategory };
